(() => {
  const dataNode = document.getElementById('irori-share-data');
  if (!dataNode) return;
  const data = JSON.parse(dataNode.textContent);
  const base = 'https://irorinaru.attendme.shop';
  const productContext = () => {
    const handle = location.hash.startsWith('#preview-product=')
      ? location.hash.slice('#preview-product='.length) : data.currentProduct;
    return data.products.find(p => p.id === handle);
  };
  const content = kind => {
    const p = kind === 'product' && productContext();
    const selector = document.querySelector('#preview-variant, #variant');
    let variant = p && selector ? selector.options[selector.selectedIndex]?.textContent.split(' — ')[0].trim() || '' : '';
    if (['全1種', 'Default Title'].includes(variant)) variant = '';
    const title = p ? `炉なる1周年記念グッズ「${p.name}」${variant ? ' / ' + variant : ''}`
      : kind === 'game' ? '炉なる1周年記念 ミニゲームで遊んでみてね！' : '炉なる1周年記念グッズをチェック！';
    return { text: title + '\n#炉なる', url: base + (p ? p.path : kind === 'game' ? '/#anniversary-card' : '/') };
  };
  const refresh = group => {
    const c = content(group.dataset.iroriShare);
    group.querySelector('[data-share-x]').href = 'https://x.com/intent/tweet?' + new URLSearchParams({ text: c.text, url: c.url });
    group.querySelector('[data-share-line]').href = 'https://social-plugins.line.me/lineit/share?' + new URLSearchParams({ url: c.url, text: c.text });
    group.querySelector('textarea').value = c.text + '\n' + c.url;
  };
  const mount = group => {
    if (group.dataset.shareReady) return;
    group.dataset.shareReady = 'true';
    group.classList.add('irori-inline-share');
    const title = document.createElement('p');
    title.className = 'irori-inline-share-title';
    title.textContent = group.dataset.iroriShare === 'game' ? '遊んだ感想をシェアしてね！' : group.dataset.iroriShare === 'product' ? 'このグッズをシェア' : '#炉なる をつけて応援してね！';
    const actions = document.createElement('div');
    actions.className = 'irori-inline-share-actions';
    const x = document.createElement('a');
    x.dataset.shareX = ''; x.textContent = 'Xでシェア ↗';
    const line = document.createElement('a');
    line.dataset.shareLine = ''; line.textContent = 'LINEで紹介 ↗';
    const copy = document.createElement('button');
    copy.type = 'button'; copy.textContent = '文面とURLをコピー';
    actions.append(x, line, copy);
    const status = document.createElement('p');
    status.className = 'irori-inline-share-status'; status.setAttribute('role', 'status');
    const fallback = document.createElement('textarea');
    fallback.hidden = true; fallback.readOnly = true; fallback.rows = 4;
    fallback.setAttribute('aria-label', 'コピー用の共有文面とURL');
    group.append(title, actions, status, fallback);
    refresh(group);
    // Ordinary same-tab links retain the mobile tap gesture and avoid popup handling.
    for (const link of [x, line]) link.addEventListener('click', () => refresh(group));
    copy.addEventListener('click', async () => {
      refresh(group);
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(fallback.value);
        fallback.hidden = true;
        status.textContent = 'コピーしました！ 感想を添えて投稿してね';
      } catch {
        fallback.hidden = false; fallback.focus(); fallback.select();
        fallback.setSelectionRange(0, fallback.value.length);
        status.textContent = '長押しまたは Ctrl/Cmd+C でコピーできます';
      }
    });
  };
  const mountAll = () => {
    document.querySelectorAll('[data-irori-share]').forEach(mount);
    const host = document.querySelector('#main .product-copy');
    if (!host || !productContext() || host.querySelector('[data-irori-share]')) return;
    const group = document.createElement('div'); group.dataset.iroriShare = 'product';
    const form = host.querySelector('form');
    if (form) form.after(group); else host.append(group);
    mount(group);
  };
  mountAll();
  const main = document.getElementById('main');
  if (main) new MutationObserver(mountAll).observe(main, { childList: true });
  window.addEventListener('hashchange', mountAll);
  document.addEventListener('change', event => {
    if (event.target.matches('#preview-variant, #variant')) document.querySelectorAll('[data-irori-share="product"]').forEach(refresh);
  });
})();
